import { Box } from '@mui/material';

interface Props { height?: number }

export function BrandLogo({ height = 32 }: Props) {
  return <Box component="img" src="/ai-planet-logo.png" alt="AI Planet" sx={{ height, width: 'auto', display: 'block', alignSelf: 'flex-start', flexShrink: 0 }} />;
}
